'use client';

import { getClientSideGnbInfo } from '@utils/gnbUtils';
import {
  GnbPcMegaMenuInfo,
  NewGnbInfo,
  NewGnbInfoV2,
} from '@wconcept/wconcept-common/models/renewal/gnb';
import { PopupResopnse } from '@wconcept/wconcept-common/models/renewal/popup';
import { SearchKeywordInfo } from '@wconcept/wconcept-common/models/renewal/search';
import { useEffect, useState } from 'react';

function useGnbController({
  initialGnbInfo,
  initialMarketingPopup,
  initialMegaMenu,
  initialSearchInitInfo,
}: {
  initialGnbInfo?: NewGnbInfo[];
  initialMarketingPopup?: PopupResopnse;
  initialMegaMenu?: GnbPcMegaMenuInfo;
  initialSearchInitInfo?: SearchKeywordInfo;
}) {
  const [gnbInfo, setGnbInfo] = useState(initialGnbInfo);
  const [marketingPopup, setMarketingPopup] = useState(initialMarketingPopup);
  const [megaMenu, setMegaMenu] = useState(initialMegaMenu);
  const [searchInitInfo, setSearchInitInfo] = useState(initialSearchInitInfo);

  useEffect(() => {
    const initGnbInfo = async () => {
      const res = await getClientSideGnbInfo();
      setGnbInfo(res?.gnbInfo);
      setMegaMenu(res?.megaMenu);
      setSearchInitInfo(res?.searchInitInfo);
      setMarketingPopup(res?.marketingPopup);
    };
    initGnbInfo();
  }, []);

  return { gnbInfo, marketingPopup, megaMenu, searchInitInfo };
}

export default useGnbController;
